module.exports = __webpack_public_path__ + "img/twitter-icon.5b852f18.svg";